document.addEventListener("DOMContentLoaded",function(){let e=document.querySelector(".product-grid-container");e&&new MutationObserver(function(t){t.forEach(function(r){r.addedNodes.length&&BSS_B2B.observer.productSubject.notifyObserver("ProductMutate","ProductPriceMutate")})}).observe(e,{childList:!0})});

/* SM08-17 — B2B sale badge: show "X% Off" when BSS B2B rewrites a price below the
   server-rendered retail price. Self-gating: guests have no BSS rules, so no price
   mutation happens and nothing is rendered. One badge = total percent off the
   displayed retail price (real sale + B2B combined); BSS's slashed original
   price stays visible beside it. Cart/checkout untouched. */
(function () {
  "use strict";
  if (window.__mtB2bSaleBadge) return;
  window.__mtB2bSaleBadge = true;
  var TEMPLATE = window.MT_PERCENT_OFF_TEMPLATE || "{{ percent }}% Off";

  function parseMoneyCents(text) {
    if (!text) return null;
    var matches = String(text).replace(/&nbsp;/g, "").match(/[\d][\d.,]*/g);
    if (!matches || !matches.length) return null;
    /* BSS may render original + sale price inside the container; the selling price
       is the last one. With a single price this equals the first. */
    var value = parseFloat(matches[matches.length - 1].replace(/,/g, ""));
    return isNaN(value) ? null : Math.round(value * 100);
  }

  var originalBadges = new WeakMap(); // price root -> server-rendered badge text (or null)

  function ensureBadge(root) {
    var badge = root.querySelector(".price__badge-sale");
    if (!badge) {
      var row = document.createElement("span");
      row.className = "price__badge-row";
      badge = document.createElement("span");
      /* mt-b2b-sale-badge makes the badge visible even without .price--on-sale
         (component-price.css hides .price__badge-sale by default). */
      badge.className = "badge price__badge-sale mt-b2b-sale-badge";
      var scheme = root.getAttribute("data-mt-badge-scheme");
      if (scheme) badge.className += " " + scheme;
      row.appendChild(badge);
      root.appendChild(row);
    }
    return badge;
  }

  function processPriceRoot(root) {
    var retailCents = parseInt(root.getAttribute("data-mt-price-cents"), 10);
    if (!retailCents || retailCents <= 0) return;
    /* SM01-30: merch-locked badge text (e.g. "50% Off Mitt"). When present the
       percent math must never overwrite it. */
    var lockedBadge = root.getAttribute("data-mt-badge-text") || "";
    var container = root.querySelector(".price__container");
    var currentCents = parseMoneyCents(container ? container.textContent : root.textContent);
    if (currentCents == null) return;

    var badge = root.querySelector(".price__badge-sale");

    if (currentCents === retailCents) {
      /* BSS price matches server price (or reverted): restore server badge state. */
      if (originalBadges.has(root)) {
        var originalText = lockedBadge || originalBadges.get(root);
        if (badge) {
          if (originalText) {
            if (badge.textContent !== originalText) badge.textContent = originalText;
          } else {
            badge.remove();
          }
        }
        originalBadges.delete(root);
      }
      root.classList.remove("price--b2b-sale");
      return;
    }

    var percent = Math.round(((retailCents - currentCents) * 100) / retailCents);
    if (percent < 1) return;
    root.classList.add("price--b2b-sale");
    /* BSS's struck original price stays visible (component-price.css no longer
       suppresses it) — the badge shows the combined percent on top of it. */
    if (!originalBadges.has(root)) {
      originalBadges.set(root, badge ? badge.textContent : null);
    }
    badge = ensureBadge(root);
    var label = lockedBadge || TEMPLATE.replace("{{ percent }}", String(percent)).replace("{{percent}}", String(percent));
    if (badge.textContent !== label) badge.textContent = label;
  }

  function scanAll() {
    var roots = document.querySelectorAll("[data-mt-price-cents]");
    for (var i = 0; i < roots.length; i++) processPriceRoot(roots[i]);
  }

  function init() {
    scanAll();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        scanAll();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
